import React, { useEffect, useState } from "react";
import HubspotForm from "react-hubspot-form";
import { addElements } from "../utils/hubspot-forms";
import {
  SpinnerIcon,
  LoadingSpinner,
  Wrapper,
} from "../utils/hubspot-forms/formStyles";
import { Section, BackgroundVariant, BackgroundVariantProps } from "../Section";
import { InputVariantTypes } from "@ecologi/shared";
import { theme } from "../theme";
import { useHubspotFormSubmitListener } from "../utils/use-hubspot-form-submit-listener";
import Script from "next/script";

export type LeadGenFormProps = {
  title?: string;
  subtitle?: string;
  onSubmit?: () => void;
} & BackgroundVariantProps;

const inputBackgroundMapper = {
  [BackgroundVariant.CREAM]: theme.colors.snowdrop,
  [BackgroundVariant.WHITE]: theme.colors.mist,
  [BackgroundVariant.TRANSPARENT]: theme.colors.mist,
  [BackgroundVariant.GREY]: theme.colors.snowdrop,
  [InputVariantTypes.DEFAULT]: theme.colors.mist,
};

export const HubspotLeadGenerationForm = ({
  title,
  subtitle,
  backgroundVariant,
  onSubmit,
}: LeadGenFormProps) => {
  const [formReady, setFormReady] = useState(false);

  const inputBg =
    inputBackgroundMapper[backgroundVariant || BackgroundVariant.CREAM];

  // react-hubspot-form requires jQuery to handle onSubmit events
  // so this hook creates a custom listener to handle it instead
  useHubspotFormSubmitListener(onSubmit);

  useEffect(() => {
    if (formReady) addElements();
  }, [formReady]);

  return (
    <Section backgroundVariant={backgroundVariant} id="get-in-touch">
      {title && (
        <Section.HeadingWrapper>
          <Section.Title use="featureTitle" as="h2">
            {title}
          </Section.Title>
          {subtitle && (
            <Section.Subtitle use="subtitle2" as="h2">
              {subtitle}
            </Section.Subtitle>
          )}
        </Section.HeadingWrapper>
      )}
      <Wrapper inputBg={inputBg}>
        <HubspotForm
          portalId={process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID}
          formId={process.env.NEXT_PUBLIC_HUBSPOT_LEAD_GEN_FORM_EMBED_ID}
          onReady={() => {
            setFormReady(true);
          }}
          cssClass="main-leadgen-form"
          loading={
            <LoadingSpinner>
              <SpinnerIcon />
            </LoadingSpinner>
          }
        />
        <Script
          src="https://app.revenuehero.io/scheduler.min.js"
          // This must load AFTER hubspots form javascript. Using lazyOnload ensures RH will not
          // load until after the DOMContentLoaded event, which will only happen after the hubspot
          // javascript has loaded.
          strategy="lazyOnload"
          onLoad={() => {
            const hero = new (window as any).RevenueHero({
              routerId: process.env.NEXT_PUBLIC_REVENUEHERO_LEAD_GEN_ROUTER_ID,
            });
            hero.schedule(
              `hsForm_${process.env.NEXT_PUBLIC_HUBSPOT_LEAD_GEN_FORM_EMBED_ID}`
            );
          }}
        />
      </Wrapper>
    </Section>
  );
};
